<template>
  <v-dialog
      :value="value"
      max-width="500"
      @click:outside="close"
  >
    <v-card>
      <v-card-title>
        １次承認依頼
      </v-card-title>
      <v-card-text>
        <v-select
            dense
            hide-details="auto"
            outlined
            label="支店*"
            :items="branches"
            v-model="branch"
            class="mb-4"
            :item-text="item => item.name"
            :item-value="item => item.name"
            @change="changeBranch"
            no-data-text="該当データがありません。"
            :rules="[(v) => !!v || '支店を選択してください。']"
        >
        </v-select>
        <v-select
            dense
            hide-details="auto"
            outlined
            label="承認者*"
            :items="om_list"
            v-model="confirmer"
            class="mb-4"
            :rules="[(v) => !!v || '承認者を選択してください。']"
            :item-value="item => item.email"
            no-data-text="該当データがありません。"
        >
          <template v-slot:selection="{item}">
            {{item.name}} {{ item.name ? '|' : null }} {{item.email}}
          </template>
          <template v-slot:item="{item}">
            {{item.name}} {{ item.name ? '|' : null }} {{item.email}}
          </template>
        </v-select>
        <v-textarea
            v-model="requestComment"
            label="コメント"
            outlined
        ></v-textarea>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn @click="close" depressed>キャンセル</v-btn>
        <v-btn @click="sendRequest" color="primary" :disabled="!confirmer">依頼</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "RequestConfirmationDialog",
  props: ['value', 'folderId', 'report'],
  data(){
    return {
      om_list: [],
      confirmer: null,
      requestComment: '',
      branches: [],
      branch: null
    }
  },

  methods: {
    close(){
      this.confirmer = null;
      this.$emit('input');
    },
    sendRequest(){
      store.showLoadingOverlay(true)
      this.axios
          .post(`/api/report/request-confirmation/${this.folderId}`,
              {confirmer: this.confirmer,
                comment: this.requestComment.trim(),
                type: 'branch_confirm',
                updated_at: this.report.updated_at
              })
          .then((response) => {
            store.showSuccessDialog('相手に確認を依頼しました。');
            this.close();
            this.$emit('requested', response.data);
          })
          .catch((error) => {
            store.showErrorDialog(error.response.data.message);
            if (error.response.status === 403){
              this.$emit('updateOutdatedReport', error.response.data.report, error.response.data.report_pdf_pages);
            }
            this.$emit('input');
          })
          .then(() => {
            store.showLoadingOverlay(false);
          });
    },
    changeBranch(){
      this.confirmer = null;
      const branch = this.branches.find(i => i.name === this.branch);
      this.om_list = branch.members;
    }
  },

  created() {
    this.axios
        .get('/api/branch')
        .then((response) => {
          this.branches = response.data
        });
    this.axios
        .get('/api/branch/' + this.folderId)
        .then((response) => {
          this.om_list = Object.values(response.data.members);
          this.branch = response.data.name;
        });
  }
}
</script>

<style scoped>

</style>
